import React from "react";
import FormBase from "../../../../components/forms/Form";
import { Box } from "@chakra-ui/react";
import { useAddCashFlowFormController } from "./useAddCashFlowFormController";

export default function AddCashFlowForm(props: any) {
  const controller = useAddCashFlowFormController(props);

  return (
    <Box>
      {props.goBackButton}
      <FormBase
        isLoading={controller.isLoading}
        title="Add Cashflow"
        subtitle="Use this form to add a cashflow entry to your portfolio."
        onSubmit={controller.submitPayload}
        submitText="Create cashflow"
        schema={controller.schema}
      />
    </Box>
  );
} 